import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PatientMedicalHistoryConstants } from '../store/patientMedicalHistory.constants'
import { getPatientMedicalHistorySelector } from '../selectors'
import { IPatientMedicalHistoryState } from '../store/patientMedicalHistory.types'
import { getPcrIdSelector } from '../../home/selectors'
import { savePatientMedicalHistory, setSavePatientMedicalHistoryResponse } from '../store/patientMedicalHistory.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { setHasPatient } from '../../patientInformation/store/patientInformation.actions'

export function* saveMedicalHistory() {
  const patientMedicalHistory: IPatientMedicalHistoryState = yield select(getPatientMedicalHistorySelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      patient: {
        ...pcrDoc.patient,
        patientMedicalHistory,
      },
    }
    try {
      yield put(setHasPatient(true))
      const response: string = yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      yield put(setSavePatientMedicalHistoryResponse(response))
      yield put(savePatientMedicalHistory())
    } catch (e) {
      yield put(throwPcrException(`savePatientMedicalHistory() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}
export function* saveMedicalHistorySaga() {
  yield takeLatest(
    [
      PatientMedicalHistoryConstants.SET_SELECTED_MEDICAL_HISTORY,
      PatientMedicalHistoryConstants.SET_SELECTED_MEDICAL_HISTORY_PNNV,
      PatientMedicalHistoryConstants.SET_SELECTED_MEDICAL_HISTORY_ICD_NEMSIS_BASIC,
      PatientMedicalHistoryConstants.SET_OBTAINED_FROM,
      PatientMedicalHistoryConstants.SET_EMERGENCY_INFO_FORM,
    ],
    performWithMutexHOG,
    saveMedicalHistory
  )
}
